import React, { useState } from 'react';
import cx from 'classnames';
import styles from './Users.module.scss';
import { useTranslation } from 'react-i18next';
import { useUserContext } from '../../../../context/UserContext';
import { formatToDateString } from '../../../../utils/TimeUtil';
import TextWithOptionalTooltip from './TextWithOptionalTooltip';
import DotsBtn from '../../../../components/Menu/DotsBtn';
import Tooltip from '../../../../components/Tooltip/Tooltip';

const UserItem = ({ user, isUsersLoading, querySearch, handleUserCardClicked, handleDotsBtn }) => {
  const [isHover, setIsHover] = useState(false);
  const { user: currentUser } = useUserContext();

  const { t } = useTranslation();

  return (
    <div
      onClick={() => handleUserCardClicked(user.username)}
      className={cx(styles.userRow, { [styles.usersLoading]: isUsersLoading, [styles.deactivated]: !user.enabled })}
      onMouseOver={() => setIsHover(true)}
      onMouseLeave={() => setIsHover(false)}
    >
      {!user.enabled && (
        <Tooltip
          classNameTooltip={styles.deactivatedTooltip}
          text={t('company.settings.users.deactivated_tooltip')}
          isHover={isHover}
          position="middle"
        />
      )}
      <div className={styles.nameItem}>
        <TextWithOptionalTooltip textToHighlight={user.name} searchWords={[querySearch]} />
      </div>
      <div className={styles.emailItem}>
        <TextWithOptionalTooltip textToHighlight={user.email} searchWords={[querySearch]} />
      </div>
      <div className={styles.lastSeenItem}>{formatToDateString(user.lastSeen) || '-'}</div>
      {user?.username != currentUser.username && (
        <div className={styles.actionsItem}>
          <DotsBtn onClick={e => handleDotsBtn(e, user)} />
        </div>
      )}
    </div>
  );
};

export default UserItem;
